import { render } from "./Login.vue?vue&type=template&id=d87934ba"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=d87934ba&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\9consulting-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__